import { CommonService } from 'api-new/generated';
import { useQuery } from 'react-query';

export const VEHICLE_LOOKUP_QUERY_KEY = 'VehicleLookupQuery';

type VehicleLookupParams = {
  regNo?: string;
};

export const useVehicleLookupQuery = (params: VehicleLookupParams, options?: { enabled?: boolean }) =>
  useQuery(
    [VEHICLE_LOOKUP_QUERY_KEY, params.regNo],
    () => CommonService.getCommonLookUpAndUpdateVehicle(params.regNo),
    {
      enabled: !!params.regNo && options?.enabled !== false
    }
  );
